import { StatisticsApi } from '@hefe/store';
import ChartPickerComponent from '../chart-picker/chart-picker.component';

export default function UsersStatisticsComponent() {
  const { data, isFetching } = StatisticsApi.useFetchUsersStatisticsQuery();

  return <ChartPickerComponent charts={data ?? []} loading={isFetching} />;
}
